<div class="main-layout-wrapper">
  @if (isReactShellReady$ | async) {
    @if (shouldUseReactUI$ | async) {
      <app-react-app-wrapper [isUseAngular]="true"></app-react-app-wrapper>
    } @else {
      <app-topbar-kendo></app-topbar-kendo>

      <div class="main-layout-content">
        <app-sidebar
          [menuItems$]="menuItems$"
          [isExpanded]="isSidebarExpanded"
          [logoSrc]="'/connect.svg'"
          [logoAlt]="'BL.INK'"
          [appName]="'BL.INK'"
          [expandedWidth]="272"
          [collapsedWidth]="80"
          (expandedChange)="onSidebarExpandedChange($event)"
        >
        </app-sidebar>
        <main class="main-content">
          @if (showAngularContent$ | async) {
            <router-outlet></router-outlet>
          } @else {
            <app-react-app-wrapper [basePath]="'/'" [isUseAngular]="false"></app-react-app-wrapper>
          }
        </main>
      </div>
    }
  }
</div>
